<template>
  <div class="m-page">
    <div class="m-info-box">
      <div class="m-info-tit"><img src="@/assets/img/home/Union.png" alt=""><span>退款信息</span>
        <div v-if="isType==1" class="m-info-btn">
          <p @click="apply()">撤销申请</p>
        </div>
      </div>
      <div class="m-nav"><span>报名名称</span><p>{{obj.urName}}</p></div>
      <div class="m-nav"><span>退款金额</span><p>{{obj.refundAmount ? obj.refundAmount:''}}元</p></div>
      <div class="m-nav"><span>退款原因</span><p>{{obj.refundReason}}</p></div>
      <div class="m-nav"><span>申请时间</span><p>{{obj.refundSubmitTime}}</p></div>
      <div v-if="isType==2" class="m-nav"><span>退款方式</span><p>{{obj.refundType==1 ? '原路退回' : '人工退款'}}</p></div>
    </div>
  </div>
</template>

<script>

  export default {
    props:{
      isType:{
        type:Number,
        default:1
      },
      obj:{
        type:Object,
        default: () => {}
      }
    },
    components: {},
    data () {
      return {
        infoObj: {}
      }
    },
    created () {

    },
    methods: {
      apply(){
        if(this.obj.examineStatus==0){
          this.$emit('apply')
        }else {
          this.utils.toastError('撤销失败，您的申请已经审核。')
        }

      }
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  .m-page {
    .m-info-box{
      background: #ffffff;
      border-radius: 4px;
      padding: 15px 12px 0 12px;
      margin-top: 18px;
      .m-info-tit{
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        >img{
          width: 16px;
          height: 16px;
        }
        >span{
          color: #2B6CF9;
          font-weight: bold;
          margin-left: 3px;
        }
        .m-info-btn{
          flex: 1;
          text-align: right;
          display: flex;
          justify-content: flex-end;
          >p{
            padding: 4px 9px;
            border-radius: 11px;
            border: 1Px solid #333333;
          }
        }
      }
      .m-nav{
        padding-bottom: 20px;
        display: flex;
        >span{
          display: inline-block;
          width: 90px;
          color: #8D8F93;
        }
        >p{
          flex: 1;
          text-align: right;
        }
      }
    }
  }
</style>

